import { Inline } from '../../Inline';
import React, { PropsWithChildren } from 'react';
import { Box } from '../../Box';

export function BasicNavigationLayout({ left, right, children }: PropsWithChildren<Props>) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0',
        left,
        right,
        height: 'calc(100% - var(--shadow-space))'
      }}
      className="slick-arrow"
    >
      <Inline sx={{ height: '100%', alignItems: 'center' }}>{children}</Inline>
    </Box>
  );
}

interface Props {
  left?: string | string[];
  right?: string | string[];
}
